// Shared Color Palettes

// Originally from SpendPlan v2 (data/colors.ts + utils/colors.ts) — promoted to
// src/ during the v2→v1 merge so v1 code can use the same tokens. Lives
// alongside `theme.ts` (the MUI theme). For semantic palette tokens (primary,
// success, error, etc.), prefer `theme.palette.*` from `theme.ts`. The values
// below are domain-specific palettes that have no direct MUI equivalent.

// Semantic accent palette (used by SpendPlan v2 cards/dialogs)

export const COLORS = {
	ai: { dark: '#6a1b9a', light: '#f3e5f5', main: '#9c27b0' },
	error: { dark: '#b91c1c', light: '#fef2f2', main: '#dc2626' },
	info: { dark: '#0369a1', light: '#f0f9ff', main: '#0284c7' },
	primary: { dark: '#1d4ed8', light: '#eff6ff', main: '#2563eb' },
	success: { dark: '#15803d', light: '#f0fdf4', main: '#16a34a' },
	warning: { dark: '#c2410c', light: '#fff7ed', main: '#ea580c' },
};

// Section accent colors (per-entity left-border palette)

// Despite the name "GRADIENTS", these are flat accent colors with white
// backgrounds — kept for backwards compatibility with the SpendPlan v2 callers.

export const GRADIENTS = {
	workPlan: {
		bg: '#ffffff',
		border: '#d97706',
		icon: '#d97706',
		text: '#111827',
		subtitle: '#374151',
		lightBg: '#ffffff',
		accent: '#d97706',
	},
	condition: {
		bg: '#ffffff',
		border: '#0d9488',
		icon: '#0d9488',
		text: '#111827',
		subtitle: '#374151',
		lightBg: '#ffffff',
		accent: '#0d9488',
	},
	activity: {
		bg: '#ffffff',
		border: '#7c3aed',
		icon: '#7c3aed',
		text: '#111827',
		subtitle: '#374151',
		lightBg: '#ffffff',
		accent: '#7c3aed',
	},
	financial: {
		bg: '#ffffff',
		border: '#16a34a',
		icon: '#16a34a',
		text: '#111827',
		subtitle: '#374151',
		lightBg: '#ffffff',
		accent: '#16a34a',
	},
	contract: {
		bg: '#ffffff',
		border: '#2563eb',
		icon: '#2563eb',
		text: '#111827',
		subtitle: '#374151',
		lightBg: '#ffffff',
		accent: '#2563eb',
	},
	payment: {
		bg: '#ffffff',
		border: '#7c3aed',
		icon: '#7c3aed',
		text: '#111827',
		subtitle: '#374151',
		lightBg: '#ffffff',
		accent: '#7c3aed',
	},
	document: {
		bg: '#ffffff',
		border: '#4f46e5',
		icon: '#4f46e5',
		text: '#111827',
		subtitle: '#374151',
		lightBg: '#ffffff',
		accent: '#4f46e5',
	},
};

// Category colors (project components/categories visualizations)

export const categoryColors = {
	infrastructure: '#2196F3',
	capacityBuilding: '#4CAF50',
	institutionalSupport: '#9C27B0',
	trainingServices: '#FF9800',
	classroomResources: '#009688',
	healthServices: '#E91E63',
	agriculture: '#8BC34A',
	waterSanitation: '#00BCD4',
	education: '#3F51B5',
	socialProtection: '#795548',
	other: '#607D8B',
} as const;

// Fund flow allocation chart colors

export const fundFlowColors = {
	planned: '#1F6BCE',
	committed: '#A4C7F6',
	verified: '#F5C453',
	redeemed: '#66BB6A',
	remaining: '#E0E0E0',
} as const;
